import navitagionTranslation from './index.json';

export default navitagionTranslation;
